import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type DocumentReport } from '../hooks/useArchivedDocumentReportsInfiniteQuery'

import { DeleteButton } from './DeleteButton'
import { UnarchiveButton } from './UnarchiveButton'

export type CommandsCellProps = {
  dataItem: DocumentReport
}

export const CommandsCell = ({
  dataItem: documentReport,
}: CommandsCellProps) => (
  <td>
    <HStack backgroundColor="transparent" spacing={1}>
      <UnarchiveButton documentReport={documentReport} />

      <DeleteButton documentReport={documentReport} />
    </HStack>
  </td>
)
